import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const GoogleOAuthSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Processing authentication...");

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Check for OAuth errors from Google
        const error = searchParams.get("error");
        if (error) {
          console.error("[OAuth Success] OAuth error:", error);

          // Parse state to get source URL for error redirect
          const state = searchParams.get("state");
          let sourceUrl = "http://localhost:3000"; // fallback
          let errorReturnPath = "/calendar";

          if (state) {
            try {
              const stateData = JSON.parse(atob(state));
              sourceUrl = stateData.sourceUrl || sourceUrl;
              // The Google Meet connect flow (signed state from the API) goes back to its own
              // page, so the owner sees why nothing got connected. The login keeps /calendar.
              if (stateData.purpose === "google-meet" && stateData.returnUrl) {
                errorReturnPath = stateData.returnUrl;
              }
            } catch (e) {
              console.error("Could not parse state for error redirect");
            }
          }

          // Redirect back to source with error
          const separator = errorReturnPath.includes("?") ? "&" : "?";
          const errorUrl = `${sourceUrl}${errorReturnPath}${separator}error=${encodeURIComponent(
            error
          )}`;
          window.location.href = errorUrl;
          return;
        }

        // Get the code and state from Google
        const code = searchParams.get("code");
        const state = searchParams.get("state");

        if (!code || !state) {
          console.error("[OAuth Success] Missing code or state parameters");
          setStatus("Authentication failed: Missing required parameters");
          return;
        }

        // Parse the state to get our original data
        let stateData;
        try {
          stateData = JSON.parse(atob(state));
        } catch (e) {
          console.error("[OAuth Success] Invalid state data:", e);
          setStatus("Authentication failed: Invalid state data");
          return;
        }

        setStatus("Completing authentication...");

        // Get the full source URL (with protocol and port)
        const sourceUrl = stateData.sourceUrl;

        if (!sourceUrl) {
          console.error("[OAuth Success] No source URL found in state");
          setStatus("Authentication failed: Invalid source URL");
          return;
        }

        // Use the returnUrl from state data, fallback to /calendar if not provided
        const returnPath = stateData.returnUrl || "/calendar";
        
        // Parse existing parameters from returnPath if any
        const [pathOnly, existingQuery] = returnPath.split('?');
        const existingParams = new URLSearchParams(existingQuery || '');
        
        // Build the return URL with the OAuth data, preserving existing parameters
        const returnParams = new URLSearchParams({
          code: code,
          state: state,
          oauth_return: "true",
        });
        
        // Merge existing parameters with OAuth parameters
        const finalParams = new URLSearchParams();
        
        // Add existing parameters first
        existingParams.forEach((value, key) => {
          finalParams.set(key, value);
        });
        
        // Add OAuth parameters (these will override any duplicates)
        returnParams.forEach((value, key) => {
          finalParams.set(key, value);
        });
        
        // Build final URL
        const returnUrl = `${sourceUrl}${pathOnly}?${finalParams.toString()}`;

        // Redirect back to the original tenant URL
        setTimeout(() => {
          window.location.href = returnUrl;
        }, 1000);
      } catch (error: any) {
        setStatus(`Authentication failed: ${error.message}`);
      }
    };

    handleOAuthCallback();
  }, [searchParams]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #4CAF50",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px",
          }}
        ></div>
        <h2
          style={{
            color: "white",
          }}
        >
          Google Authentication
        </h2>
        <p
          style={{
            color: "white",
          }}
        >
          {status}
        </p>
      </div>
    </div>
  );
};

export default GoogleOAuthSuccess;
